import React from "react";
import { Link } from "react-router-dom";
import { QUESTIONS } from "../../../constants";
import { GoogleAnalyticsEnum, triggerFunction } from "../../../utils/google-analytics";
import { toUpperSnake } from "../../../utils";
import Image from "../../../common/footer/Images/Image";

const InterviewSeriesOne = ({ data, classes, bgGray }) => {
    return (
        <div
            className={`edu-blog blog-type-2 variation-2 radius-small ${classes ? classes : ""} ${bgGray === "enable" ? "bg-color-gray" : ""}`}
        >
            <div className="inner">
                <div className="thumbnail">
                    <Link
                        to={
                            process.env.PUBLIC_URL +
                            `/interview-questions/${data?.categoryId}/${data?.slug}`
                        }
                        onClick={() =>
                            triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                `CATEGORY_${toUpperSnake(data?.categoryId)}_SERIES_${toUpperSnake(data?.name)}`,
                            )
                        }
                    >
                        <Image src={data?.thumbnail} alt="Thumbnail" fill />
                    </Link>
                    {/* <div class="top-position status-group left-bottom">
                        <span class="eduvibe-status status-04">{data?.difficulty}</span>
                    </div> */}
                </div>
                <div className="content">
                    <div className="status-group status-style-5 mt--10">
                        <span className="eduvibe-status status-05">
                            <i class="ri-questionnaire-line"></i> {data?.questionCount}{" "}
                            {QUESTIONS}
                        </span>

                        <span className="eduvibe-status status-05">
                            <i className="ri-time-line"></i> {data?.experienceRange}
                        </span>
                    </div>
                    <h5 className="title">
                        <Link
                            to={
                                process.env.PUBLIC_URL +
                                `/interview-questions/${data?.categoryId}/${data?.slug}`
                            }
                            onClick={() =>
                                triggerFunction(
                                    GoogleAnalyticsEnum.LINK,
                                    `CATEGORY_${toUpperSnake(data?.categoryId)}_SERIES_${toUpperSnake(data?.name)}`,
                                )
                            }
                        >
                            {data?.name}
                        </Link>
                    </h5>
                </div>
            </div>
        </div>
    );
};

export default InterviewSeriesOne;
